export default __webpack_public_path__ + "static/media/Particular.1b7fbde0.jpg";